import React from 'react';
import styles from './SideNav_.module.scss';

export const defaultItems = [
  { id: 'home', label: 'Home', icon: '/assets/svg/side-nav/home.svg' },

  { id: 'latest', label: 'Latest', icon: '/assets/svg/side-nav/latest.svg' },
  { id: 'program', label: 'Program', icon: '/assets/svg/side-nav/program.svg' },
  {
    id: 'programsDegree',
    label: 'Programs & Degrees',
    icon: '/assets/svg/side-nav/programs-degree.svg',
  },
  {
    id: 'studentLife',
    label: 'Student Life',
    icon: '/assets/svg/side-nav/student-life.svg',
  },
  { id: 'about', label: 'About', icon: '/assets/svg/side-nav/about.svg' },

  { id: 'grad', label: 'Graduation', icon: '/assets/svg/side-nav/grad.svg' },
  {
    id: 'academyEx',
    label: 'Academy+',
    icon: '/assets/svg/side-nav/academy-ex.svg',
  },
  {
    id: 'testimonials',
    label: 'Testimonials',
    icon: '/assets/svg/side-nav/testimonials.svg',
  },
];

const SideNav = ({ items = defaultItems, activeIndex, activeId, onChange }) => {
  const resolvedActiveIndex =
    typeof activeIndex === 'number'
      ? activeIndex
      : Math.max(
          0,
          items.findIndex((i) => i.id === activeId)
        );

  return (
    <nav
      aria-label="Section navigation"
      className={`${styles.sideNav} ${activeIndex === 0 ? styles.hideNav : ''}`}
    >
      <div className={styles.rail} role="tablist">
        {items.map((item, idx) => {
          const isActive = idx === resolvedActiveIndex;
          return (
            <button
              key={item.id ?? idx}
              type="button"
              aria-label={item.label}
              aria-selected={isActive}
              role="tab"
              onClick={() => onChange?.(idx, item)}
              className={styles.btn}
              data-active={isActive ? 'true' : 'false'}
            >
              <span className={styles.icon}>
                <img src={item.icon} alt="" loading="lazy" decoding="async" />
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default SideNav;
